import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Main from "./main";
import LoginPage from "./pages/login/Login";
import OAuth2RedirectHandler from "./login/OAuth2RedirectHandler";
import Logout from "./components/logout/Logout";

const App = () => {
  return (
    <div className="app">
      <div className="app-top-box"></div>
      <div className="app-body">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/profile" element={<Navigate to="/home" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
          <Route path="*" element={null} />
        </Routes>
        <Main />
      </div>
    </div>
  );
};

export default App;
